import { render, staticRenderFns } from "./PsychologistMap.vue?vue&type=template&id=004372ea&"
import script from "./PsychologistMap.vue?vue&type=script&lang=ts&"
export * from "./PsychologistMap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports